import {
  ToggleButtonGroup,
  ToggleIconButton,
} from "@tokenterminal/core/ui/input/toggle/ToggleButtonGroup"
import {
  type ThemePreference,
  themeOptions,
  useThemeContext,
} from "@tokenterminal/core/ui/theme/ThemeContext"

export const ThemeSwitcherToggle = () => {
  const { preferredTheme, setPreferredTheme } = useThemeContext()

  return (
    <ToggleButtonGroup
      selectedKey={preferredTheme}
      onSelectionChange={(key) => setPreferredTheme(key as ThemePreference)}
      size="small"
      className="pointer-events-auto"
    >
      {Object.entries(themeOptions).map((entry) => {
        const [theme, { icon, label }] = entry as unknown as [
          ThemePreference,
          (typeof themeOptions)[keyof typeof themeOptions],
        ]
        return (
          <ToggleIconButton key={theme} id={theme} icon={icon} label={label} />
        )
      })}
    </ToggleButtonGroup>
  )
}
